module.exports = __webpack_public_path__ + "img/t4-c1.57dbcb69.png";